var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"update-progress-bar"},[_c('div',[_c('img',{attrs:{"src":require('@/assets/img/vertical_logo.svg')}}),_c('div',{staticClass:"bar"},[_c('div',{staticClass:"h-100",style:(`width: ${_vm.percent}%;`)})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }